module.exports = __webpack_public_path__ + "static/media/invoices.bbec626b.png";